import AudioCard from './AudioCard'

export default AudioCard
